import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestSearchPopup.XeroSearchFields', {
    xeroRequestorFieldTitle: 'Requester',
    xeroRequestorPlaceholder: 'Select requester',
    xeroDocumentReferenceFieldTitle: 'Reference',
    xeroDocumentReferencePlaceholder: 'Enter reference',
    xeroDocumentNumberFieldTitle: 'Number',
    xeroDocumentNumberPlaceholder: 'Enter number',
    xeroContactFieldTitle: 'Supplier/Customer',
    xeroContactPlaceholder: 'Select supplier/customer',
    xeroAccountFieldTitle: 'Account',
    xeroAccountPlaceholder: 'Select account',
    xeroItemFieldTitle: 'Item',
    xeroItemPlaceholder: 'Select item',
    xeroTrackingPlaceholder: 'Select {name}',
    dateGreaterEqualsPlaceholder: 'Enter date',
    dateLessEqualsPlaceholder: 'Enter date',
    dateFieldTitle: 'Date',
    dateFromLabel: 'From',
    dateToLabel: 'To',
    airwallexScheduledPaymentDateFieldTitle: 'Scheduled payment date',
    narrationFieldTitle: 'Narration',
    narrationFieldPlaceholder: 'Enter narration',
});
